const personas = {
  title: 'Personas',
  selector: {
    manage: 'Manage personas',
  },
  list: {
    title: 'Personas',
    name: 'Name',
    configuration: 'Configuration',
    add: 'Add persona',
    edit: 'Edit',
    delete: 'Delete',
    empty:
      'No custom personas yet. Create one to tailor simulations to your users.',
  },
  form: {
    create_title: 'Create persona',
    edit_title: 'Edit persona',
    name: 'Name',
    name_placeholder: 'e.g. Low vision user',
    name_required: 'Persona name is required',
    strengths: 'Strengths',
    strengths_placeholder:
      'e.g. Patient with forms, familiar with common UI patterns',
    weaknesses: 'Weaknesses',
    weaknesses_placeholder:
      'e.g. Struggles with small text, easily distracted by animations',
    blurred_vision: 'Blurred vision',
    shaky_hands: 'Shaky hands',
    input_devices: 'Input devices',
    input_devices_mouse: 'Mouse',
    input_devices_keyboard: 'Keyboard',
    input_devices_touch: 'Touch',
    languages: 'Languages',
    select_language: 'Select a language',
    remove_language: 'Remove language',
    language_proficiency: '{{language}} proficiency',
    color_blindness_type: 'Color blindness type',
    color_blindness_intensity: 'Effect strength',
    wcag_appraisals: 'WCAG appraisals',
    wcag_appraisals_level: 'WCAG level',
    intensity: 'Intensity',
    unable_to_save:
      'Unable to save persona. Check the configuration and try again.',
    tabs: {
      label: 'Persona settings',
      general: 'General',
      languages: 'Languages',
      input_devices: 'Input devices',
      accessibility: 'Accessibility',
    },
    tooltips: {
      blurred_vision:
        'Simulates reduced visual acuity by blurring the interface. Useful for testing how users with low vision experience your product.',
      shaky_hands:
        'Simulates tremor or limited motor control by adding shake to pointer movement. Helps evaluate targets and controls for users with motor impairments.',
      color_blindness:
        'Simulates color vision deficiency so you can see how palettes, charts, and status indicators appear to users with different types of color blindness.',
      color_blindness_intensity:
        'Controls how strongly the selected color blindness type is applied. 0 is no effect, 1 is the full simulation.',
      input_devices:
        'Choose which input methods this persona can use during a simulation.',
      languages:
        'Add languages this persona speaks and set how well they understand each one.',
      language_proficiency:
        'How well this persona understands {{language}}. Used to tailor simulation behavior for users with limited proficiency.',
      wcag_appraisals:
        'Controls whether simulations with this persona generate WCAG accessibility remarks. Use simulation default unless you want this persona to always enable or disable appraisals.',
      wcag_appraisals_level:
        'Conformance level used when generating WCAG remarks during simulations.',
    },
  },
  wcag_appraisals_mode: {
    enabled: 'Enabled',
    disabled: 'Disabled',
  },
  language: {
    en: 'English',
    fr: 'French',
  },
  understanding_level: {
    NONE: 'None',
    BASIC: 'Basic',
    INTERMEDIATE: 'Intermediate',
    ADVANCED: 'Advanced',
    FLUENT: 'Fluent',
    NATIVE: 'Native',
  },
  delete: {
    title: 'Delete persona',
    description:
      'Are you sure you want to delete "{{name}}"? This cannot be undone.',
    confirm: 'Delete',
  },
  config: {
    language_proficiency: '{{language}}: {{level}}',
    none: 'No accessibility effects',
    blurred_vision_enabled: 'Blurred vision ({{intensity}})',
    shaky_hands_enabled: 'Shaky hands ({{intensity}})',
    color_blindness_enabled: '{{type}} ({{intensity}})',
    wcag_appraisals_enabled: 'WCAG {{level}}',
    wcag_appraisals_disabled: 'WCAG appraisals disabled',
    input_devices_enabled: 'Input: {{devices}}',
  },
  color_blindness: {
    NONE: 'None',
    PROTANOPIA: 'Protanopia',
    DEUTERANOPIA: 'Deuteranopia',
    TRITANOPIA: 'Tritanopia',
    ACHROMATOPSIA: 'Achromatopsia',
  },
} as const;

export default personas;
